import { createContext, useContext } from "react"

import { FindIngestionSettingsResponseDto } from "~/gen/api"

type ProductImportContextType = {
  isLoadingOwners: boolean
  owners: string[]
  ingestionSettings?: FindIngestionSettingsResponseDto
  isIngestionSettingsLoading: boolean
  setOwners: React.Dispatch<React.SetStateAction<string[]>>
}

export const ProductImportContext = createContext<ProductImportContextType>({
  isLoadingOwners: false,
  owners: [],
  ingestionSettings: undefined,
  isIngestionSettingsLoading: false,
  setOwners: () => undefined,
})

export const useProductImportContext = () => useContext(ProductImportContext)
